import { maintenanceGuard } from '@examdojo/auth';
import { syllabusUserSubscriptionsResolver, topicsTreeResolver } from '@examdojo/category/v2';
import { RootUrlParts } from '../app.model';
import { AuthGuard } from '../auth/auth.guard';
import { allSyllabusesResolver } from '../shared/syllabus.resolver';
import { userSettingsResolver } from '../user/user-settings';
import { alreadyOnboardedGuard } from './onboarding.guard';

export const onboardingRoutes = [
  {
    path: RootUrlParts.Onboarding,
    canActivate: [maintenanceGuard, AuthGuard, alreadyOnboardedGuard],
    resolve: {
      syllabuses: allSyllabusesResolver,
      syllabusUserSubscriptions: syllabusUserSubscriptionsResolver,
      topicsTree: topicsTreeResolver,
      userSettings: userSettingsResolver,
    },
    loadComponent: () => import('./onboarding.component').then((m) => m.OnboardingComponent),
  },
];
